import PropTypes from 'prop-types'
import classnames from 'classnames'
import pluralize from 'pluralize'
import { includes, truncate } from 'lodash'
import { Checkbox, CheckboxGroup } from 'components/forms'
import { InlineCounter, FilterSection } from './filter-section'
import { getFilteredProductsCount, SECTIONS, FILTERS } from '../../helpers'

export const ProductTypeFilterSection = ({
  open,
  products,
  categories,
  setCategories,
  options,
  selfExcludingFilters,
}) => (
  <FilterSection
    disabled={options.length === 0}
    title={SECTIONS.PRODUCT_TYPE}
    open={open}
    collapsedContent={categories.join(', ')}
  >
    <CheckboxGroup>
      <Checkbox
        checked={categories.length === 0}
        onChange={(e) => (e.target.checked ? setCategories([]) : () => {})}
        label={
          <div>
            <span>{`View All ${pluralize(
              SECTIONS.PRODUCT_TYPE,
              categories.length
            )}`}</span>
            <InlineCounter count={products.length} />
          </div>
        }
        size="large"
      />
      {options.map((category) => {
        const filteredCount = getFilteredProductsCount(products, {
          ...selfExcludingFilters,
          [FILTERS.CATEGORIES]: [category],
        })
        const disabled = filteredCount === 0
        return (
          <Checkbox
            key={category}
            label={
              <div className={classnames({ disabled })}>
                <span>{truncate(category, { length: 26 })}</span>
                <InlineCounter count={filteredCount} />
              </div>
            }
            disabled={filteredCount === 0}
            checked={includes(categories, category)}
            onChange={(e) => {
              const addCategory = e.target.checked
              const newList = addCategory
                ? [...categories, category]
                : categories.filter((c) => c !== category)
              setCategories(newList)
            }}
            size="large"
          />
        )
      })}
    </CheckboxGroup>
  </FilterSection>
)

ProductTypeFilterSection.propTypes = {
  open: PropTypes.bool.isRequired,
  products: PropTypes.array.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  setCategories: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selfExcludingFilters: PropTypes.object.isRequired,
}
